// API client with auth
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("lq_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (!["/", "/auth", "/pricing", "/forgot"].includes(path)) {
        localStorage.removeItem("lq_token");
        window.location.href = "/auth";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
